import { render, staticRenderFns } from "./EditLogistics.vue?vue&type=template&id=0614ca00&"
import script from "./EditLogistics.vue?vue&type=script&lang=js&"
export * from "./EditLogistics.vue?vue&type=script&lang=js&"
import style0 from "./EditLogistics.vue?vue&type=style&index=0&id=0614ca00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports